import { render } from "./SortingPanel.vue?vue&type=template&id=9d63db20&ts=true"
import script from "./SortingPanel.vue?vue&type=script&lang=ts"
export * from "./SortingPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__